import type { AppRouter } from '@/server/api/root';
import { createTRPCProxyClient } from '@trpc/client';
import { getTRPCClientConfig } from './api';

const trpcClient = createTRPCProxyClient<AppRouter>(getTRPCClientConfig());

export { trpcClient };
